import React from 'react';
import PromotionFactory from 'factories/Promotion';
import StorageService from 'services/StorageService';
import style from './style.scss';

const PromotionQuantity = (props) => {
    const item = props.item ? props.item : null;
    const {isLoading} = props
    const inCart = item && item.inCart || item.quantityTotal;
    const dataUser = StorageService.getSecureItem('userData');
    const cencoPrime = dataUser && dataUser.CencoPrime_2020 ? dataUser.CencoPrime_2020 : '';

    const getPromotion = (item) => {
        let promotion = null;

        if(item.promotionVerifyQty || item.promotionVerifyQty === null) return item.promotionVerifyQty;

        const withFactory = typeof props.withFactory !== 'undefined' ? props.withFactory : true;
        const promotions = withFactory ? PromotionFactory.create(item) : item.promotions;
        if(promotions?.length) {
            promotions.map((prom) => {
                if(prom.type === 'for_the_price_of' && prom.isPriceView){
                    promotion = prom;
                }
            });
        }

        item.promotionVerifyQty = promotion;

        return promotion;
    }

    const promotion = getPromotion(item);

    if(!promotion) return '';

    const modQuantity = promotion.minQuantity - (inCart % promotion.minQuantity);

    if (!(modQuantity && (modQuantity !== promotion.minQuantity)) || (promotion.cencoPrime && !cencoPrime) || isLoading) return '';

    return (
        <div className="product-quantity-wrap">
            <div className="product-quantity-text">Agrega {modQuantity} unid. y lleva la promoción</div>
        </div>
    )
}

export default PromotionQuantity;
